// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.post-detail-container {
  width: 100%;
}

.detail-links-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

:root[data-maincontent="wide"] .post-detail-container {
  padding-left: 20px;
  padding-right: 20px;
}

.back-link {
  display: inline-block;
  margin-bottom: 20px;
  color: var(--accent-primary);
  font-weight: 600;
  text-decoration: none;
  transition: color 0.2s;
  padding: 20px 10px;
  margin: 15px 0;
  background: var(--card-bg);
}

.back-link-right {
  margin-left: auto;
}

.flex-parent-preview {
  display: block;
  margin: 0 0 16px;
  padding: 14px 16px;
  border: 1px solid var(--border-color);
  border-left: 4px solid var(--accent-primary);
  border-radius: 10px;
  text-decoration: none;
  background:
    linear-gradient(120deg, color-mix(in srgb, var(--accent-primary) 7%, transparent), transparent 45%),
    var(--bg-secondary);
  transition: transform 0.16s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.flex-parent-preview:hover {
  transform: translateY(-1px);
  border-color: color-mix(in srgb, var(--accent-primary) 45%, var(--border-color));
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}

.flex-parent-preview-kicker {
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-secondary);
  margin-bottom: 4px;
}

.flex-parent-preview-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.flex-parent-preview-head-copy {
  min-width: 0;
}

.flex-parent-preview-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid color-mix(in srgb, var(--accent-primary) 35%, var(--border-color));
  flex-shrink: 0;
  background: var(--bg-primary);
}

.flex-parent-preview-title {
  font-weight: 700;
  color: var(--text-primary);
  word-break: break-word;
}

.flex-parent-preview-body {
  color: var(--text-secondary);
  line-height: 1.45;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.flex-parent-preview-body.is-loading {
  font-style: italic;
}

.back-link:hover {
  color: var(--accent-hover);
  text-decoration: underline;
  margin-top: 14px;
  margin-bottom: 16px;
  margin-left: -1px;
  box-shadow: 1px 3px 5px var(--accent-hover);
  background-color: transparent;
}

.comment-breadcrumb {
  background: var(--bg-tertiary);
  border-left: 3px solid var(--accent-primary);
  padding: 12px 16px;
  margin-bottom: 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.breadcrumb-label {
  font-size: 0.9rem;
  color: var(--text-secondary);
  font-weight: 500;
}

.breadcrumb-link {
  color: var(--accent-primary);
  text-decoration: none;
  font-weight: 600;
  font-size: 0.9rem;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background 0.2s;
}

.breadcrumb-link:hover {
  background: var(--bg-tertiary);
  text-decoration: underline;
}

.comments-section {
  margin-top: 30px;
}

.comments-title {
  font-size: 1.3rem;
  margin-bottom: 20px;
  color: var(--text-primary);
  padding-bottom: 10px;
  border-bottom: 2px solid var(--border-color);
}

.flex-comments-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.comment {
  position: relative;
  transition: margin-left 0.2s;
  margin-bottom: 10px;
}

.toggle-replies-btn {
  background: transparent;
  border: none;
  color: var(--accent-primary);
  cursor: pointer;
  padding: 8px 12px;
  font-size: 0.9rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
  transition: color 0.2s;
}

.toggle-replies-btn:hover {
  color: var(--accent-hover);
  text-decoration: underline;
}

.show-more-levels-btn {
  background: var(--bg-tertiary);
  border: 1px solid var(--accent-primary);
  color: var(--accent-primary);
  cursor: pointer;
  padding: 8px 16px;
  font-size: 0.85rem;
  font-weight: 600;
  border-radius: 6px;
  margin: 8px 0;
  transition: all 0.2s;
}

.show-more-levels-btn:hover {
  background: var(--accent-primary);
  color: var(--bg-secondary);
}

.deep-comment-notice {
  background: var(--bg-tertiary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 12px;
  margin: 8px 0;
}

.view-comment-btn {
  display: inline-block;
  background: var(--accent-primary);
  color: var(--bg-secondary);
  text-decoration: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 600;
  margin-top: 8px;
  transition: background 0.2s;
}

.view-comment-btn:hover {
  background: var(--accent-hover);
}

.comment-replies {
  margin-top: 10px;
}

/* Visual nesting indicator for .comment */
.comment::before {
  content: '';
  position: absolute;
  left: -10px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: var(--border-color);
}

/* Styling for FlexDetail nested comments */
.flex-comment-node {
  position: relative;
  margin-bottom: 10px;
  margin-left: 12px; /* single consistent left margin */
}

.nested-replies {
  margin-top: 8px;
  margin-left: 0; /* removed margin-left */
  border-left: none; /* removed visual border */
  padding-left: 8px; /* slight padding for separation */
}

.flex-comment-node::before {
  content: '';
  position: absolute;
  left: -12px;
  top: 4px;
  bottom: 0;
  width: 2px;
  background: var(--border-color);
  opacity: 0.6;
}

.flex-comment-node:hover::before {
    background: var(--accent-hover);
    opacity: 1;
}

/* Removed level-specific margin rules to use uniform margin on .flex-comment-node */

@media (max-width: 768px) {
  .nested-replies { margin-left: 10px !important; padding-left: 8px; }
  .flex-comment-node.level-1, .flex-comment-node.level-2, .flex-comment-node.level-3, .flex-comment-node.level { margin-left: 10px; }
}

/* Different colors for nesting levels */
.comment[style*="margin-left: 20px"]::before {
  background: var(--accent-primary);
}

.comment[style*="margin-left: 40px"]::before {
  background: var(--success-color);
}

.comment[style*="margin-left: 60px"]::before {
  background: var(--error-color);
}

.comment[style*="margin-left: 80px"]::before {
  background: var(--accent-primary);
}

@media (max-width: 768px) {
  .detail-links-row {
    flex-wrap: wrap;
  }

  .back-link-right {
    margin-left: 0;
  }

  .flex-parent-preview {
    padding: 12px 13px;
  }

  .comments-title {
    font-size: 1.1rem;
  }

  /* Reduce nesting indent on mobile */
  .comment[style*="margin-left"] {
    margin-left: 10px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/FlexDetail.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,4CAA4C;EAC5C,mBAAmB;EACnB,qBAAqB;EACrB;;uBAEqB;EACrB,8EAA8E;AAChF;;AAEA;EACE,2BAA2B;EAC3B,gFAAgF;EAChF,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,oFAAoF;EACpF,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,4CAA4C;EAC5C,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;EACvC,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,iCAAiC;EACjC,0BAA0B;EAC1B,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,SAAS;EACT,UAAU;EACV,+BAA+B;AACjC;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB,EAAE,kCAAkC;AACvD;;AAEA;EACE,eAAe;EACf,cAAc,EAAE,wBAAwB;EACxC,iBAAiB,EAAE,0BAA0B;EAC7C,iBAAiB,EAAE,kCAAkC;AACvD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,SAAS;EACT,UAAU;EACV,+BAA+B;EAC/B,YAAY;AACd;;AAEA;IACI,+BAA+B;IAC/B,UAAU;AACd;;AAEA,oFAAoF;;AAEpF;EACE,kBAAkB,4BAA4B,EAAE,iBAAiB,EAAE;EACnE,+GAA+G,iBAAiB,EAAE;AACpI;;AAEA,wCAAwC;AACxC;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,oCAAoC;EACpC;IACE,4BAA4B;EAC9B;AACF","sourcesContent":[".post-detail-container {\r\n  width: 100%;\r\n}\r\n\r\n.detail-links-row {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n}\r\n\r\n:root[data-maincontent=\"wide\"] .post-detail-container {\r\n  padding-left: 20px;\r\n  padding-right: 20px;\r\n}\r\n\r\n.back-link {\r\n  display: inline-block;\r\n  margin-bottom: 20px;\r\n  color: var(--accent-primary);\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n  transition: color 0.2s;\r\n  padding: 20px 10px;\r\n  margin: 15px 0;\r\n  background: var(--card-bg);\r\n}\r\n\r\n.back-link-right {\r\n  margin-left: auto;\r\n}\r\n\r\n.flex-parent-preview {\r\n  display: block;\r\n  margin: 0 0 16px;\r\n  padding: 14px 16px;\r\n  border: 1px solid var(--border-color);\r\n  border-left: 4px solid var(--accent-primary);\r\n  border-radius: 10px;\r\n  text-decoration: none;\r\n  background:\r\n    linear-gradient(120deg, color-mix(in srgb, var(--accent-primary) 7%, transparent), transparent 45%),\r\n    var(--bg-secondary);\r\n  transition: transform 0.16s ease, box-shadow 0.2s ease, border-color 0.2s ease;\r\n}\r\n\r\n.flex-parent-preview:hover {\r\n  transform: translateY(-1px);\r\n  border-color: color-mix(in srgb, var(--accent-primary) 45%, var(--border-color));\r\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.flex-parent-preview-kicker {\r\n  font-size: 0.78rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  color: var(--text-secondary);\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.flex-parent-preview-head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.flex-parent-preview-head-copy {\r\n  min-width: 0;\r\n}\r\n\r\n.flex-parent-preview-avatar {\r\n  width: 38px;\r\n  height: 38px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n  border: 1px solid color-mix(in srgb, var(--accent-primary) 35%, var(--border-color));\r\n  flex-shrink: 0;\r\n  background: var(--bg-primary);\r\n}\r\n\r\n.flex-parent-preview-title {\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  word-break: break-word;\r\n}\r\n\r\n.flex-parent-preview-body {\r\n  color: var(--text-secondary);\r\n  line-height: 1.45;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 3;\r\n  line-clamp: 3;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n}\r\n\r\n.flex-parent-preview-body.is-loading {\r\n  font-style: italic;\r\n}\r\n\r\n.back-link:hover {\r\n  color: var(--accent-hover);\r\n  text-decoration: underline;\r\n  margin-top: 14px;\r\n  margin-bottom: 16px;\r\n  margin-left: -1px;\r\n  box-shadow: 1px 3px 5px var(--accent-hover);\r\n  background-color: transparent;\r\n}\r\n\r\n.comment-breadcrumb {\r\n  background: var(--bg-tertiary);\r\n  border-left: 3px solid var(--accent-primary);\r\n  padding: 12px 16px;\r\n  margin-bottom: 20px;\r\n  border-radius: 8px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.breadcrumb-label {\r\n  font-size: 0.9rem;\r\n  color: var(--text-secondary);\r\n  font-weight: 500;\r\n}\r\n\r\n.breadcrumb-link {\r\n  color: var(--accent-primary);\r\n  text-decoration: none;\r\n  font-weight: 600;\r\n  font-size: 0.9rem;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.breadcrumb-link:hover {\r\n  background: var(--bg-tertiary);\r\n  text-decoration: underline;\r\n}\r\n\r\n.comments-section {\r\n  margin-top: 30px;\r\n}\r\n\r\n.comments-title {\r\n  font-size: 1.3rem;\r\n  margin-bottom: 20px;\r\n  color: var(--text-primary);\r\n  padding-bottom: 10px;\r\n  border-bottom: 2px solid var(--border-color);\r\n}\r\n\r\n.flex-comments-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.comment {\r\n  position: relative;\r\n  transition: margin-left 0.2s;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.toggle-replies-btn {\r\n  background: transparent;\r\n  border: none;\r\n  color: var(--accent-primary);\r\n  cursor: pointer;\r\n  padding: 8px 12px;\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  margin-bottom: 8px;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.toggle-replies-btn:hover {\r\n  color: var(--accent-hover);\r\n  text-decoration: underline;\r\n}\r\n\r\n.show-more-levels-btn {\r\n  background: var(--bg-tertiary);\r\n  border: 1px solid var(--accent-primary);\r\n  color: var(--accent-primary);\r\n  cursor: pointer;\r\n  padding: 8px 16px;\r\n  font-size: 0.85rem;\r\n  font-weight: 600;\r\n  border-radius: 6px;\r\n  margin: 8px 0;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.show-more-levels-btn:hover {\r\n  background: var(--accent-primary);\r\n  color: var(--bg-secondary);\r\n}\r\n\r\n.deep-comment-notice {\r\n  background: var(--bg-tertiary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  padding: 12px;\r\n  margin: 8px 0;\r\n}\r\n\r\n.view-comment-btn {\r\n  display: inline-block;\r\n  background: var(--accent-primary);\r\n  color: var(--bg-secondary);\r\n  text-decoration: none;\r\n  padding: 8px 16px;\r\n  border-radius: 6px;\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  margin-top: 8px;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.view-comment-btn:hover {\r\n  background: var(--accent-hover);\r\n}\r\n\r\n.comment-replies {\r\n  margin-top: 10px;\r\n}\r\n\r\n/* Visual nesting indicator for .comment */\r\n.comment::before {\r\n  content: '';\r\n  position: absolute;\r\n  left: -10px;\r\n  top: 0;\r\n  bottom: 0;\r\n  width: 2px;\r\n  background: var(--border-color);\r\n}\r\n\r\n/* Styling for FlexDetail nested comments */\r\n.flex-comment-node {\r\n  position: relative;\r\n  margin-bottom: 10px;\r\n  margin-left: 12px; /* single consistent left margin */\r\n}\r\n\r\n.nested-replies {\r\n  margin-top: 8px;\r\n  margin-left: 0; /* removed margin-left */\r\n  border-left: none; /* removed visual border */\r\n  padding-left: 8px; /* slight padding for separation */\r\n}\r\n\r\n.flex-comment-node::before {\r\n  content: '';\r\n  position: absolute;\r\n  left: -12px;\r\n  top: 4px;\r\n  bottom: 0;\r\n  width: 2px;\r\n  background: var(--border-color);\r\n  opacity: 0.6;\r\n}\r\n\r\n.flex-comment-node:hover::before {\r\n    background: var(--accent-hover);\r\n    opacity: 1;\r\n}\r\n\r\n/* Removed level-specific margin rules to use uniform margin on .flex-comment-node */\r\n\r\n@media (max-width: 768px) {\r\n  .nested-replies { margin-left: 10px !important; padding-left: 8px; }\r\n  .flex-comment-node.level-1, .flex-comment-node.level-2, .flex-comment-node.level-3, .flex-comment-node.level { margin-left: 10px; }\r\n}\r\n\r\n/* Different colors for nesting levels */\r\n.comment[style*=\"margin-left: 20px\"]::before {\r\n  background: var(--accent-primary);\r\n}\r\n\r\n.comment[style*=\"margin-left: 40px\"]::before {\r\n  background: var(--success-color);\r\n}\r\n\r\n.comment[style*=\"margin-left: 60px\"]::before {\r\n  background: var(--error-color);\r\n}\r\n\r\n.comment[style*=\"margin-left: 80px\"]::before {\r\n  background: var(--accent-primary);\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .detail-links-row {\r\n    flex-wrap: wrap;\r\n  }\r\n\r\n  .back-link-right {\r\n    margin-left: 0;\r\n  }\r\n\r\n  .flex-parent-preview {\r\n    padding: 12px 13px;\r\n  }\r\n\r\n  .comments-title {\r\n    font-size: 1.1rem;\r\n  }\r\n\r\n  /* Reduce nesting indent on mobile */\r\n  .comment[style*=\"margin-left\"] {\r\n    margin-left: 10px !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
